
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class OrderTotals extends Vue {
    @Prop({ default: 0 }) subTotal: number;
    @Prop({ default: 0 }) discount: number;
    @Prop({ default: () => [] }) customerHandoffCharge: number;
    @Prop({ default: () => [] }) taxes: TaxModel[];
    @Prop({ default: 0 }) tip: number;
    @Prop({ default: 0 }) total: number;
}
